import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, addArrayValue } from 'redux-form';
import ficheValidation from './ficheValidation';
import { LinkContainer } from 'react-router-bootstrap';
import ObjectSelect from '../form/ObjectSelect';
import { Alert, OverlayTrigger, Tooltip, Tabs, Tab, Col, Button } from 'react-bootstrap';

import productForm from './product.json';
import { generateFicheInputs } from 'utils/generateFicheInputs.js';
import { routeActions } from 'react-router-redux';

import * as FicheActions from 'redux/modules/fiches';
import * as ProductActions from 'redux/modules/products';

import _ from 'underscore';
import { analyseState } from 'utils/analyseState';

require('./count-down.css');

import { translate } from 'react-i18next';

@translate(['common'])
@connect(
	state => ({
		smsActions: state.products.smsActions,
		user: state.auth.user,
		from: state.products.from,
		site_state: state.products.site_state,
		modifyGSMError: state.products.modifyGSMError,
		modifyGSMSuccess: state.products.modifyGSMSuccess,
		modifyGSMLoading: state.products.modifyGSMLoading,
		mcpCalled: state.products.mcpCalled,

	}),
	dispatch => bindActionCreators({ ...ProductActions, ...FicheActions }, dispatch)
)

export default class ModifyPhoneNumber extends Component {

	constructor(props) {
		super(props);

		this.intervalNumber = 0;

		this.state = {
			success: false,
			error: false,
		};

		this.hasReloaded = false; // Empêche la boucle infinie de reload

		this.modifyGSM = this.modifyGSM.bind(this);
		this.reloadFiche = this.reloadFiche.bind(this);
	}


	componentDidMount() {
		var self = this;
		
		// Vérifier l'état du modif_champ après F5 pour afficher succès/erreur
		var gsmModif = _.find(this.props.modif_champ, {action:'modify_gsm'});
		var actions = analyseState(this.props.site_state);
		var siteAction = actions.asts1;
		
		console.log('[ModifyGSM] componentDidMount', {
			modif_champ: this.props.modif_champ,
			gsmModif: gsmModif,
			site_state: this.props.site_state,
			siteAction: siteAction
		});
		
		// Vérifier d'abord site.etat (plus fiable car mis à jour immédiatement)
		if (siteAction && siteAction.state >= 3) {
			if (siteAction.state == 3) {
				console.log('[ModifyGSM] componentDidMount: succès via site.etat');
				this.setState({ success: true });
				return;
			} else if (siteAction.state > 3) {
				console.log('[ModifyGSM] componentDidMount: erreur via site.etat');
				this.setState({ error: siteAction.stateLabel });
				return;
			}
		}
		
		// Ne vérifier modif_champ que si etat === 0 (en cours)
		// etat === 1 est un succès passé, pas besoin de l'afficher
		// Le polling n'est plus nécessaire - le WebSocket notifie directement les changements d'état

	}

	componentWillUnmount() {
		if (this.interval) {
			clearInterval(this.interval);
		}
	}

	componentDidUpdate(prevProps) {

		var self = this;

		if (self.props.product) {
			var ficheID = self.props.product.s_id;
		} else {
			var ficheID = self.props.urlParams.ficheID;
		}

		var actions = analyseState(this.props.site_state);



		// Après F5, from est false mais hasCurrentGSMModif peut être true
		if (this.props.from == 'modifyPhoneNumber' || this.props.hasCurrentGSMModif) {

			var action = actions.asts1
			var smsAction = this.props.smsActions[this.props.site.id] && this.props.smsActions[this.props.site.id]['asts1'];

			console.log('[ModifyGSM] componentDidUpdate', {
				from: this.props.from,
				hasCurrentGSMModif: this.props.hasCurrentGSMModif,
				smsAction: smsAction,
				action: action,
				site_state: this.props.site_state,
				intervalNumber: this.intervalNumber
			});

			// Après F5: smsAction est undefined, mais on peut quand même vérifier action.state
			// Guard: ne pas boucler si déjà success/error
			if (!smsAction && this.props.hasCurrentGSMModif && action.state >= 3 && !this.state.success && !this.state.error) {
				console.log('[ModifyGSM] Après F5, action terminée, state=', action.state);
				// Arrêter l'intervalle démarré dans componentDidMount
				if (this.interval) {
					clearInterval(this.interval);
					this.interval = null;
				}
				if (action.state == 3) {
					this.setState({ success: true });
					// La modale recharge la fiche automatiquement à sa fermeture (handleCloseModal)
					try {
						this.props.handleOpenModal(<span>{this.props.t('modifyGSM.valid_number')} <i className="text-success fa fa-check" aria-hidden="true"></i></span>);
					} catch(e) {}
				} else if (action.state > 3) {
					this.setState({ error: action.stateLabel });
					try {
						this.props.handleOpenModal(<span>{this.props.t('modifyGSM.invalid_number')}: {action.stateLabel} <i className="text-danger fa fa-times" aria-hidden="true"></i></span>);
					} catch(e) {}
				}
			}

			//Si une action a été déjà instanciée (smsAction peut être undefined après F5)
			if (smsAction) {

				// Détecter la fin d'action via transition de site_state (WS met intervalLaunched=false avant componentDidUpdate)
				var stateChanged = prevProps.site_state !== this.props.site_state;
				var actionInProgress = smsAction.smsSent == true || this.props.hasCurrentGSMModif;

				if (stateChanged && actionInProgress && !this.state.success && !this.state.error) {
					if (action.state == 3) {
						this.props.endInterval(action.type, ficheID);
						this.setState({ success: true });
						try {
							this.props.handleOpenModal(<span>{this.props.t('modifyGSM.valid_number')} <i className="text-success fa fa-check" aria-hidden="true"></i></span>);
						} catch(e) {}
					} else if (action.state > 3) {
						this.props.endInterval(action.type, ficheID);
						this.hasReloaded = true;
						this.setState({ success: false, error: action.stateLabel });
						try {
							this.props.handleOpenModal(<span>{this.props.t('modifyGSM.invalid_number')}: {action.stateLabel} <i className="text-danger fa fa-times" aria-hidden="true"></i></span>);
						} catch(e) {}
					}
				}

				// Recharger la fiche après succès
				if (smsAction.intervalFinished == true && !this.hasReloaded && !this.state.error) {
					this.hasReloaded = true;
					this.reloadFiche();
				}

			}


		}
	}


	reloadFiche() {
		var self = this;
		//self.props.loadProduct( self.props.urlParams.productID,  self.props.urlParams);
		this.setState({ error: false, success: false })
		self.props.reloadForm()
		self.props.triggerError('', 'phone')
	}


	modifyGSM() {

		var self = this;

		const {t} = self.props

		var user = this.props.user;
		if (user.role == 'admin') {
			var userId = this.props.urlParams.cid;
		} else {
			var userId = user.name;
		}

		var actionLabel = t("modifyGSM.modify_gsm")

		var payload = { type: 'asts1', user: userId };

		if (this.props.product) {
			this.props.site.id = this.props.product.s_id
		}


		this.props.modifyGSM(
			this.props.site.id,
			this.props.product.id,
			this.props.gsm,
			this.props.t_id,
			userId,
			this.props.urlParams,
			this.props.product.identification_NUM_SERIAL,
			this.props.identificationType).then(() => {
				this.props.sendSMS(
					self.props.site,
					payload,
					self.props.urlParams,
					'asts1',
					self.props.state,
					actionLabel, "modifyPhoneNumber")
			})


	}


	render() {

		const {t} = this.props

		var tooltip =
			<Tooltip id="tooltip">
				<strong>
					{t("modifyGSM.call_to_verify")}					
	  			<br /><br />
					{this.props.is_master == true &&
						<span>
							{t("modifyGSM.modify_warning")}							
	  					</span>
					}
				</strong>

			</Tooltip>

		var otr = (
			<OverlayTrigger placement="top" overlay={tooltip}>
				<i className="fa fa-info-circle"></i>
			</OverlayTrigger>
		)

		var intervalLaunched = false;
		var error = false;

		var already_requested = false;
		if (this.props.site.id in this.props.smsActions) {
			if (this.props.smsActions[this.props.site.id].asts1) {
				intervalLaunched = this.props.smsActions[this.props.site.id].asts1.intervalLaunched;
				error = this.props.smsActions[this.props.site.id].asts1.error
			}
		}

		if (this.props.hasCurrentGSMModif) {
			already_requested = true
		}

		return (

			<span>
				{(!this.state.error && !this.state.success) &&
					<div>
						<Button 
							style={{ display: 'inline', margin: '-13px 0 0 -15px' }}
							disabled={(intervalLaunched && this.props.from == 'modifyPhoneNumber') || already_requested || this.props.hasCurrentGSMModif || this.props.hasCurrentResetSerial} 
							bsStyle="danger" onClick={this.modifyGSM}
						>
							<div>
								{this.props.identificationType === 'ASC-IP' ? t("modifyGSM.modify_canip") : t("modifyGSM.modify_number")} {otr}&nbsp;
			    				{((intervalLaunched && this.props.from == 'modifyPhoneNumber') || already_requested || this.props.hasCurrentGSMModif || this.props.hasCurrentResetSerial) &&
									<i className="fa fa-cog fa-spin fa-1x fa-fw"/>
								}
							</div>
						</Button>
						<br />
					</div>
				}

				{/*error &&
					<Alert bsStyle="danger">{error}</Alert>
				*/}

				{this.state.success &&
					<Alert bsStyle="success" style={{ margin: '0 0 0 -15px' }} >
						{t("modifyGSM.valid_number")}
					</Alert>
				}

				{this.state.error != false && (
					<Alert bsStyle="danger" style={{ margin: '0 0 0 -15px' }}>
						{t("modifyGSM.invalid_number")}: {this.state.error}
						<br/>
						<Button bsStyle="primary" type="button" onClick={this.reloadFiche}>
							{t("modifyGSM.reload_sheet")}
						</Button>
					</Alert>)
				}

				{this.state.timeout && (
					<Alert bsStyle="danger" style={{ margin: '0 0 0 -15px' }}>
						{t("modifyGSM.timeout")}
					</Alert>)
				}


				{(this.props.modifyGSMError != false) &&
					<Alert bsStyle="danger" style={{ margin: '0 0 0 -15px' }}>
						{this.props.modifyGSMError}
					</Alert>
				}

			</span>

		);



	}
}

